<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Banco Central</h4>
            <div class="small text-muted">Administración de consultas por situación crediticia a la central de deudores</div>
          </b-col>
          <b-col>            
            <b-icon icon="question-circle-fill" class="h3 pull-right mt-2 module-help-information" v-b-popover.hover="help"></b-icon>            
          </b-col>             
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <b-row>
            <b-col sm="12" md="6" lg="4"> 
              <Widget :configWidget="configWidget" reference="list_service_status" :hasAccess="configWidget.elements.listServiceStatus" />
            </b-col>          
          </b-row>
        </b-col>  
        <b-col lg="3">
        
          <b-list-group class="mb-1" v-if="!isSeller && configSubView.elements.configuration">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfiguration()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuración</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configurar la conexión para conectarnos al servicio
              </p>
            </b-list-group-item>
          </b-list-group>                     

          <b-list-group class="mb-1" v-if="configSubView.elements.query">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openQuery()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Consultar</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Realizar una consulta de situación crediticia a la base de datos del Banco Central
              </p>
            </b-list-group-item>
          </b-list-group>  

          <b-list-group class="mb-1" v-if="!isSeller && configSubView.elements.logs">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openLogs()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Logs</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Detalle de cada consulta realizada al Banco Central
              </p>
            </b-list-group-item>
          </b-list-group>          

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.BCRA,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.BCRA,
          profile_id: Profiles.PERSONAL,
          elements: {             
            listServiceStatus: true,
          }
        },
        configSubView: {
          module_id: Modules.BCRA,
          profile_id: Profiles.PERSONAL,
          elements: {
            configuration: true,
            query: true,
            logs: true,
            php_custom: true,
          }
        },        
        primaryColor: '',
        arr: {
          PHPCustom: []
        },        
        help: {
          title:'¿Cómo funciona este módulo?',
          content: () => { 
            return `Un usuario con perfil <b>STAFF</b>, puede configurar la herramienta, realizar 
                    consultas y acceder al log.
                    <br><br>
                    Un usuario con perfil <b>STAFF</b> y configurado como <b>VENDEDOR</b> 
                    solo puede realizar consultas.`
          },            
          html: true
        }                
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.listServiceStatus = Helper.hasAccessWidget(this.configWidget, 'list_service_status')            
      /* Fin configuracion */


      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.configuration = Helper.showAccessView(this.configSubView, 'configuration')            
      this.configSubView.elements.query = Helper.showAccessView(this.configSubView, 'query')            
      this.configSubView.elements.logs = Helper.showAccessView(this.configSubView, 'logs')            
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */         
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    computed: {
      isSeller(){
        if(Helper.getSeller()) {
          return true
        } else {
          return false
        }
      }
    },     
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      
      openConfiguration() {
        this.$router.push({ name: 'BCRAStaffConfiguration' })
      },      

      openQuery() {
        this.$router.push({ name: 'BCRAStaffQuery' })
      },   

      openLogs() {
        this.$router.push({ name: 'BCRAStaffLog' })
      },      

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.BCRA)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
